
import { Vue, Component } from 'vue-property-decorator'
import ErrorPage from './components/collections/error/ErrorPage.vue'
import ErrorPageDetails from './components/collections/error/ErrorPageDetails.vue'

import './assets/css/reset.css'
import './assets/css/colours.css'
import './assets/css/fonts.css'
import './assets/css/layout.css'
import './assets/css/transitions.css'

@Component({
  components: {
    ErrorPage,
    ErrorPageDetails
  }
})
export default class App extends Vue {
  mounted (): void {
    // Set up the CHAT2_API config
    // (window as any).CHAT2_API = (window as any).CHAT2_API || {};
    // (window as any).CHAT2_API.args = {
    //   mode: 'widget',
    //   chat2_base_url: '//tradingmatecomau.chat2.com/',
    //   wheight: 450,
    //   wwidth: 350,
    //   pheight: 520,
    //   pwidth: 500,
    //   leaveamessage: true,
    //   check_messages: false,
    //   lang: 'eng/'
    // }

    // // Dynamically create the <script> element
    // const script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.setAttribute('crossorigin', 'anonymous')
    // script.async = true

    // const date = new Date()
    // script.src = `//tradingmatecomau.chat2.com/design/defaulttheme/js/widgetv2/index.js?${date.getFullYear()}${date.getMonth()}${date.getDate()}`

    // const firstScript = document.getElementsByTagName('script')[0]
    // if (firstScript.parentNode) {
    //   firstScript.parentNode.insertBefore(script, firstScript)
    // }
  }
}
